import { Link } from "react-router-dom";
import { useState } from "react";
import { Instagram, Mail, MapPin, Landmark, Copy, Check } from "lucide-react";

const IBAN = "GR60 0172 1300 0051 3011 9425 131";

export default function Footer() {
  const [copied, setCopied] = useState(false);

  const copyIban = async () => {
    try {
      await navigator.clipboard.writeText(IBAN.replace(/\s/g, ""));
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (_) {
      /* no-op */
    }
  };

  return (
    <footer className="relative bg-[var(--ink)] text-[var(--bg)] px-4 md:px-8 lg:px-12 py-16 md:py-24 border-t border-[var(--ink)]">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
        <div className="md:col-span-5">
          <div className="font-display text-6xl md:text-7xl lg:text-8xl leading-[0.85]">
            BLOUZES
            <span className="text-[var(--lime)]">4</span>ALL.
          </div>
          <p className="mt-6 max-w-md text-white/80 text-base leading-relaxed">
            Δημιουργούμε πρωτότυπα streetwear από την Ελλάδα. Κάθε παραγγελία μοναδική,
            κάθε σχέδιο ζωντανό.
          </p>
        </div>
        <div className="md:col-span-3 md:col-start-7">
          <div className="font-mono-caps text-[10px] mb-4 opacity-60">MENU</div>
          <ul className="space-y-2 font-display text-lg uppercase">
            <li><Link to="/" className="hover:text-[var(--lime)]">Αρχική</Link></li>
            <li><a href="/#gallery" className="hover:text-[var(--lime)]">Συλλογή</a></li>
            <li><a href="/#manifesto" className="hover:text-[var(--lime)]">Manifesto</a></li>
            <li><Link to="/epikoinonia" className="hover:text-[var(--lime)]">Επικοινωνία</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <div className="font-mono-caps text-[10px] mb-4 opacity-60">CONTACT</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-[var(--lime)]" aria-hidden="true" />
              <a
                href="mailto:medhealthgr@gmail.com"
                className="hover:text-[var(--lime)]"
              >
                medhealthgr@gmail.com
              </a>
            </li>
            <li className="flex items-center gap-2">
              <MapPin className="w-4 h-4 text-[var(--lime)]" aria-hidden="true" /> Αθήνα, Ελλάδα
            </li>
            <li className="flex items-center gap-2">
              <Instagram className="w-4 h-4 text-[var(--lime)]" aria-hidden="true" /> @blouzes4all
            </li>
          </ul>
        </div>
      </div>

      {/* Payment block */}
      <section
        aria-labelledby="payment-heading"
        className="mt-16 border border-white/15 bg-white/[0.03] p-6 md:p-8"
      >
        <div className="flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-10">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 border border-[var(--lime)] flex items-center justify-center text-[var(--lime)]">
              <Landmark className="w-5 h-5" aria-hidden="true" />
            </div>
            <div>
              <div className="font-mono-caps text-[10px] opacity-60 mb-1">
                ΤΡΟΠΟΣ ΠΛΗΡΩΜΗΣ
              </div>
              <h2 id="payment-heading" className="font-display text-2xl md:text-3xl">
                Κατάθεση σε Τράπεζα Πειραιώς
              </h2>
            </div>
          </div>

          <div className="flex-1 lg:border-l lg:border-white/15 lg:pl-10">
            <div className="font-mono-caps text-[10px] opacity-60 mb-2">IBAN</div>
            <div className="flex flex-wrap items-center gap-3">
              <code className="font-mono text-base md:text-xl tracking-wider text-[var(--lime)] select-all">
                {IBAN}
              </code>
              <button
                type="button"
                onClick={copyIban}
                aria-label="Αντιγραφή IBAN"
                className="inline-flex items-center gap-2 border border-white/40 px-3 py-1.5 font-mono-caps text-[10px] hover:bg-[var(--lime)] hover:text-[var(--ink)] hover:border-[var(--lime)] transition-colors"
              >
                {copied ? (
                  <>
                    <Check className="w-3 h-3" aria-hidden="true" /> ΑΝΤΙΓΡΑΦΗΚΕ
                  </>
                ) : (
                  <>
                    <Copy className="w-3 h-3" aria-hidden="true" /> ΑΝΤΙΓΡΑΦΗ
                  </>
                )}
              </button>
            </div>
            <p className="mt-3 text-white/70 text-sm leading-relaxed max-w-xl">
              Μετά την αποστολή της παραγγελίας στο email, καταθέτετε το ποσό
              στον παραπάνω λογαριασμό αναγράφοντας ως αιτιολογία το ονοματεπώνυμο
              και τον κωδικό της παραγγελίας.
            </p>
          </div>
        </div>
      </section>

      <div className="mt-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border-t border-white/10 pt-6 font-mono-caps text-[10px] opacity-60">
        <span>© {new Date().getFullYear()} BLOUZES4ALL.GR</span>
        <span>DESIGNED IN GREECE · PRINTED ON DEMAND</span>
        <span>MADE WITH LOVE &amp; COTTON</span>
      </div>
    </footer>
  );
}
